import axios from '../../common/axios.js'
import CryptoJS from 'crypto-js'
import Input from '../../common/forms/Input.vue'
import LoadingBtn from '../../common/ui/loading_btn.vue'

export default {
	data(){
		return {
			passwordType: 'password',
			password: '',
			email: '',
			error: false,
			message_erreur: 'connection_erreur',
			loading: false
		}
	},
	created(){
	},
	methods:{
		switchInput(){
			this.passwordType = this.passwordType == 'password' ? 'text' : 'password'
		},
		connecter(){
			var self = this;
			self.error = false;

			let infos = {
				data:{
					Profil: {
						email: self.email,
						password: self.password
					}
				}
			}

			this.loading = true;

			let login_interne_abort = axios.CancelToken.source();
			let login_interne = axios.post('/plugin_projet/plugin_projet_iannuaire/connecte', infos, {cancelToken: login_interne_abort.token});
			let login_inex_abort = axios.CancelToken.source();
			let login_inex = axios.post('api=inex/login/', infos, {cancelToken: login_inex_abort.token});

			Promise.all([
				//AS--> Demande d'autorisation de connexion à PHP
				login_interne,
				//AS--> Demande d'autorisation de connexion à API inex
				login_inex
			]).then(function (response) {
				//RZ--> Si erreur PHP avec KO: on lance une erreur
				if(typeof response[0].data == 'string' && response[0].data.substring(0,3) == 'KO:'){
					throw new Error(response[0].data);
				}else{
					//RZ--> Si connexion iNex réussie, on enregistre le token
					self.$store.commit('USER_SET_ACCESS_TOKEN', response[1].data.access_token);
					
					//AS--> Si PHP autorise la personne à se connecter
					self.$store.commit('UI_SET_MODAL', {modal: null});
					self.$store.commit('UI_SET_COMPANY_MODAL', {id:null, prev:null, next:null})
					self.$store.dispatch('init_user_data', response[0].data).then(function(){
						self.$store.dispatch('user_after_connection');
					});

				}
			}).catch(function (error) {				
				//RZ--> Annulation des requêtes
				login_inex_abort.cancel()
				login_interne_abort.cancel()

				//RZ--> Si erreur PHP avec KO: on lance une erreur
				if(typeof error.message == 'string' && error.message.substring(0,3) == 'KO:'){
					self.error = true;
					self.message_erreur = error.message.substring(3);
				}else if(error.response.status == 403 && error.response.data.detail.includes('SSO')){
					//RZ--> Si erreur SSO, on redirige vers la page de connexion SSO
					self.connexion_sso();
				}else{
					//RZ--> Si erreur iNex, on lance une erreur
					self.error = true;
					self.message_erreur = 'iNex refused to connect the user';
				}
			}).finally(function () {
				self.loading = false;
			})			
		},
		openRefashion(){
			window.open('https://inscription.recycle.refashion.fr/inscription', '_blank')
		},
		connexion_sso(){
			let uri = window.location.pathname;
			let segments = uri.split('/').filter(Boolean);
			let language = segments.length > 0 && segments[0].length === 2 ? segments[0] : 'fr';

			axios.get('/plugin_projet/plugin_projet_iannuaire/sso_login_url?language='+language).then(function (response) {
				if(response.data) {
					window.location.href = response.data;
				}
			})
		}
	},
	components: {
		Input,
		LoadingBtn
	}
}
